<template>
	<div class="shopDetail">
		<back-to></back-to>
		<!-- banner -->
		<van-swipe class="packageTour-banner-swiper" :autoplay="3000" indicator-color="white">
			<van-swipe-item v-for="(item, index) in proInfo.images" :key="index">
				<img v-lazy="item" />
			</van-swipe-item>
		</van-swipe>
		<div class="title">
			<div class="title-t">{{proInfo.name}}</div>
			<div class="title-s">
				<p>{{proInfo.score}}积分</p>
				<!-- <text>快递:免运费</text> -->
				<p></p>
			</div>
		</div>
		<div class="space"></div>
		<div class="select">
			<div class="select-l">已选</div>
			<div class="select-r">默认 1件</div>
		</div>
		<div class="space"></div>
		<van-tabs v-model="active" scrollspy sticky>
			<van-tab title="产品详情">
				<div class="content">
					<div class="content-c">{{proInfo.productDesc == null? '':proInfo.productDesc}}</div>
				</div>
			</van-tab>
			<div class="space"></div>
			<van-tab title="兑换方式">
				<div class="content">
					<div class="content-t">兑换方式</div>
					<div class="content-c">{{proInfo.exchangeDesc == null? '':proInfo.exchangeDesc}}</div>
				</div>
			</van-tab>
			<div class="space"></div>
			<van-tab title="注意事项">
				<div class="content">
					<div class="content-t">注意事项</div>
					<div class="content-c">{{proInfo.noticeDesc == null? '':proInfo.noticeDesc}}</div>
				</div>
			</van-tab>
			<div class="space"></div>
			<van-tab title="使用说明">
				<div class="content">
					<div class="content-t">使用说明</div>
					<div class="content-c">{{proInfo.instructions == null? '':proInfo.instructions}}</div>
				</div>
			</van-tab>
			<div class="space"></div>
		</van-tabs>
		<div class="btn" @click="jump">
			<p>立即兑换</p>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		Toast
	} from 'vant';
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'shopDetail',
		components: {
			BackTo
		},
		data() {
			return {
				proInfo: '',
				active: 0
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getContent()
		},
		methods: {
			jump() {
				var jsonData = {
					"userId": this.userInfo.userId,
					"ptId": this.$organizationId,
					"productId": this.$route.query.id
				}
				this.$get(
					this.$activity + '/Score/ScoreExchangeCheck', jsonData
				).then(res => {
					if (res.isSuccess) {
						this.$router.push({
							path: '/shopOrder',
							query: {
								id: this.$route.query.id,
								type: this.proInfo.type,
								actionUrl: this.proInfo.actionUrl
							}
						})
					} else {
						Toast('res.error');
					}
				})
			},
			getContent(id) {
				var jsonData = {
					id: this.$route.query.id
				}
				this.$get(
					this.$activity + '/Score/ScoreProductGetById', jsonData
				).then(res => {
					this.proInfo = res
				})
			}
		}
	}
</script>

<style scoped>
	.packageTour-banner-swiper,
	.packageTour-banner-swiper img {
		width: 100%;
		height: 375px;
	}

	.title {
		width: 750px;
		margin-top: 30px;
	}

	.title-t {
		margin-left: 20px;
		margin-right: 20px;
		font-size: 34px;
		color: #333;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.title-s {
		display: flex;
		justify-content: space-between;
		padding: 0 20px;
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.title-s p:nth-of-type(1) {
		font-size: 34px;
		color: #ff8a00;
	}

	.title-s p:nth-of-type(2) {
		font-size: 26px;
		color: #999;
	}

	.space {
		width: 100%;
		height: 20px;
		background: #f1f1f1;
	}

	.select {
		height: 80px;
		display: flex;
		justify-content: space-between;
		padding: 0 20px;
		align-items: center;
		width: 750px;
		box-sizing: border-box;
	}

	.select-l {
		font-size: 26px;
		color: #999;
	}

	.select-r {
		font-size: 26px;
		color: #333;
	}

	.btn {
		height: 88px;
		width: 100%;
		color: #fff;
		text-align: center;
		z-index: 99;
		position: fixed;
		bottom: 0px;
		left: 0px;
		background-color: #fff;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
	}

	.btn p {
		background: #ff8a00;
		height: 88px;
		width: 100%;
		line-height: 88px;
		font-size: 36px;
		display: block;
	}

	.content {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.content-t {
		font-size: 30px;
		color: #333;
		font-weight: bold;
	}

	.content-c {
		font-size: 28px;
		color: #333;
		margin-top: 30px;
		white-space: pre-wrap;
	}
</style>
